<template>
  <div class="configuration-buildings-container">
    <v-card class="stepperCard">
      <div class="scrollStep">
        <span class="stepperTitle">Create Configuration</span>
        <Stepper
          :steps="data"
          :currentStep="currentStep"
          @onStepClick="onStepClick"
        ></Stepper>
      </div>
    </v-card>
    <v-card class="formCard">
      <div
        v-show="stepData[0][currentStep].type === 'form'"
        class="form tab-content inputNPV"
      >
        <InputFieldNPV
          v-for="field in stepData[0][currentStep].fields"
          :key="field.label + field.order"
          ref="formInputField"
          :value="getValueInObject(field.var_name, field.input_type)"
          @input="setValueInObject(field.var_name, $event, field.input_type)"
          :label="field.label_client ? field.label_client : field.label"
          :variable-name="field.var_name"
          :inputType="field.input_type"
          :size="field.size"
          :required="field.required"
          :selectOptions="field.select_list_name"
          :radioOptions="field.radio_options"
          :hide="field.hide"
          :automatic-label="field.has_automatic_label"
          :checkboxOptions="field.checkbox_options"
          @updateCheckboxValue="updateCheckboxValue($event)"
          @removePhoto="addToPhotosToRemove($event)"
        />
      </div>
      <div
        v-show="
          stepData[0][currentStep].type === 'other' &&
          stepData[0][currentStep].code ===
            'simulation_configuration_street_types'
        "
        class="form tab-content inputNPVTable"
      >
        <div class="addButtonDiv">
          <v-btn
            @click="addRowTable('street_types')"
            color="#67a0b4"
            class="addButtonNPV"
          >
            <v-icon> add </v-icon>
          </v-btn>
        </div>
        <v-data-table
          :headers="headerStreets"
          :items="
            stepData[0][currentStep].fields.length > 0
              ? stepData[0][currentStep].fields
              : dataStreets
          "
          :items-per-page="10"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <input
                  class="no-border"
                  :value="dataStreets[props.index].street_type_id"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'street_type_id',
                      'street_types',
                      'number'
                    )
                  "
                  type="number"
                />
              </td>
              <td>
                <v-checkbox
                  color="accent"
                  :input-value="dataStreets[props.index].geo2trail"
                  label=""
                  @change="
                    valueTableUpdate(
                      $event,
                      props.index,
                      'geo2trail',
                      'street_types',
                      'checkbox'
                    )
                  "
                />
              </td>
              <td>
                <input
                  class="no-border"
                  :value="dataStreets[props.index].width_meter"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'width_meter',
                      'street_types',
                      'number'
                    )
                  "
                  type="number"
                />
              </td>
              <td>
                <v-checkbox
                  color="accent"
                  :input-value="dataStreets[props.index].is_private"
                  label=""
                  @change="
                    valueTableUpdate(
                      $event,
                      props.index,
                      'is_private',
                      'street_types',
                      'checkbox'
                    )
                  "
                />
              </td>
              <td>
                <v-checkbox
                  color="accent"
                  :input-value="dataStreets[props.index].disable_secondary_side"
                  label=""
                  @change="
                    valueTableUpdate(
                      $event,
                      props.index,
                      'disable_secondary_side',
                      'street_types',
                      'checkbox'
                    )
                  "
                />
              </td>
              <td>
                <input
                  class="no-border"
                  :value="dataStreets[props.index].side_cost_meter"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'side_cost_meter',
                      'street_types',
                      'number'
                    )
                  "
                  type="number"
                />
              </td>
              <td>
                <input
                  class="no-border"
                  :value="dataStreets[props.index].crossing_cost_meter"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'crossing_cost_meter',
                      'street_types',
                      'number'
                    )
                  "
                  type="number"
                />
              </td>
              <td>
                <v-checkbox
                  color="accent"
                  :input-value="dataStreets[props.index].permit_crossing"
                  label=""
                  @change="
                    valueTableUpdate(
                      $event,
                      props.index,
                      'permit_crossing',
                      'street_types',
                      'checkbox'
                    )
                  "
                />
              </td>
              <td>
                <input
                  class="no-border"
                  :value="dataStreets[props.index].opt_cost_multiplier_crossing"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'opt_cost_multiplier_crossing',
                      'street_types',
                      'number'
                    )
                  "
                  type="number"
                />
              </td>
              <td style="display:flex ; align-items: center; justify-content: space-between">
                <input
                  style="width: 80%"
                  class="no-border"
                  :value="dataStreets[props.index].urban_cost_multiplier"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'urban_cost_multiplier',
                      'street_types',
                      'number'
                    )
                  "
                  type="number"
                />
                <div style="margin-left: 8px;">
                  <app-datatable-action-buttons
                    :user-can-delete="isSuperAdmin"
                    @delete="deleteItem(props.index, 'street_types')"
                  />
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div
        v-show="
          stepData[0][currentStep].type === 'other' &&
          stepData[0][currentStep].code ===
            'simulation_configuration_surface_types'
        "
        class="form tab-content inputNPVTable"
      >
        <div class="addButtonDiv">
          <v-btn
            @click="addRowTable('surface_types')"
            color="#67a0b4"
            class="addButtonNPV"
          >
            <v-icon> add </v-icon>
          </v-btn>
        </div>
        <v-data-table
          :headers="headerSurface"
          :items="
            stepData[0][currentStep].fields.length > 0
              ? stepData[0][currentStep].fields
              : dataSurface
          "
          :items-per-page="10"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <input
                  class="no-border"
                  :value="dataSurface[props.index].surface_type_id"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'surface_type_id',
                      'surface_types',
                      'number'
                    )
                  "
                  type="number"
                />
              </td>
              <td style="display:flex ; align-items: center; justify-content: space-between">
                <input
                  class="no-border"
                  :value="dataSurface[props.index].cost_meter"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'cost_meter',
                      'surface_types',
                      'number'
                    )
                  "
                  type="number"
                />
                <app-datatable-action-buttons
                  :user-can-delete="isSuperAdmin"
                  @delete="deleteItem(props.index, 'surface_types')"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div
        v-show="
          stepData[0][currentStep].type === 'other' &&
          stepData[0][currentStep].code ===
            'simulation_configuration_railway_types'
        "
        class="form tab-content inputNPVTable"
      >
        <div class="addButtonDiv">
          <v-btn
            @click="addRowTable('railway_types')"
            color="#67a0b4"
            class="addButtonNPV"
          >
            <v-icon> add </v-icon>
          </v-btn>
        </div>
        <v-data-table
          :headers="headerRailway"
          :items="
            stepData[0][currentStep].fields.length > 0
              ? stepData[0][currentStep].fields
              : dataRailway
          "
          :items-per-page="10"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <input
                  class="no-border"
                  :value="dataRailway[props.index].name"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'name',
                      'railway_types'
                    )
                  "
                  type="text"
                />
              </td>
              <td>
                <input
                  class="no-border"
                  :value="dataRailway[props.index].crossing_cost"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'crossing_cost',
                      'railway_types',
                      'number'
                    )
                  "
                  type="number"
                />
              </td>
              <td style="display:flex ; align-items: center; justify-content: space-between">
                <v-checkbox
                  color="accent"
                  :input-value="dataRailway[props.index].geo2trail"
                  label=""
                  @change="
                    valueTableUpdate(
                      $event,
                      props.index,
                      'geo2trail',
                      'railway_types',
                      'checkbox'
                    )
                  "
                />
                <app-datatable-action-buttons
                  :user-can-delete="isSuperAdmin"
                  @delete="deleteItem(props.index, 'railway_types')"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div
        v-show="
          stepData[0][currentStep].type === 'other' &&
          stepData[0][currentStep].code ===
            'simulation_configuration_waterway_types'
        "
        class="form tab-content inputNPVTable"
      >
        <div class="addButtonDiv">
          <v-btn
            @click="addRowTable('waterway_types')"
            color="#67a0b4"
            class="addButtonNPV"
          >
            <v-icon> add </v-icon>
          </v-btn>
        </div>
        <v-data-table
          :headers="headerWaterway"
          :items="
            stepData[0][currentStep].fields.length > 0
              ? stepData[0][currentStep].fields
              : dataWaterway
          "
          :items-per-page="10"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <input
                  class="no-border"
                  :value="dataWaterway[props.index].name"
                  @input="
                    valueTableUpdate(
                      $event.target.value,
                      props.index,
                      'name',
                      'waterway_types'
                    )
                  "
                  type="text"
                />
              </td>
              <td style="display:flex ; align-items: center; justify-content: space-between">
                <v-checkbox
                  color="accent"
                  :input-value="dataWaterway[props.index].geo2trail"
                  label=""
                  @change="
                    valueTableUpdate(
                      $event,
                      props.index,
                      'geo2trail',
                      'waterway_types',
                      'checkbox'
                    )
                  "
                />
                <app-datatable-action-buttons
                  :user-can-delete="isSuperAdmin"
                  @delete="deleteItem(props.index, 'waterway_types')"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Stepper from "@/components/_Organisms/Stepper.vue";
import InputFieldNPV from "../components/InputFieldsNPV";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import { bus } from "@/main.js";
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";

export default {
  name: "ConfigurationBuildings",
  components: {
    Stepper,
    InputFieldNPV,
    AppDatatableActionButtons,
  },

  mixins: [dynamicObjectFormsMixin, checkPermissionsMixin],

  data() {
    return {
      currentStep: 0,
      isLoading: false,
      test: 1,
      data: [],
      stepData: [],
      headerStreets: [
        { text: "Street type id", value: "street_type_id" },
        { text: "Geo Trail", value: "geo2trail" },
        { text: "Width", value: "width_meter" },
        { text: "Private", value: "is_private" },
        { text: "Disable Secondary Side", value: "disable_secondary_side" },
        { text: "Side Cost Meter", value: "side_cost_meter" },
        { text: "Crossing Cost Meter", value: "crossing_cost_meter" },
        { text: "Permit Crossing", value: "permit_crossing" },
        { text: "Opt Cost Multiplier", value: "opt_cost_multiplier_crossing" },
        { text: "Urban Cost Multiplier", value: "urban_cost_multiplier" },
      ],
      dataStreets: [
        {
          street_type_id: 0,
          geo2trail: false,
          width_meter: 0,
          is_private: false,
          disable_secondary_side: false,
          side_cost_meter: 0,
          crossing_cost_meter: 0,
          permit_crossing: false,
          opt_cost_multiplier_crossing: 0,
          urban_cost_multiplier: 0,
        },
      ],
      headerSurface: [
        { text: "Surface type id", value: "surface_type_id" },
        { text: "Cost meter", value: "cost_meter" },
      ],
      dataSurface: [
        {
          surface_type_id: 0,
          cost_meter: 0,
        },
      ],
      headerRailway: [
        { text: "Railway name", value: "name" },
        { text: "Crossing cost", value: "crossing_cost" },
        { text: "Geo trail", value: "geo2trail" },
      ],
      dataRailway: [
        {
          name: "",
          crossing_cost: 0,
          geo2trail: false,
        },
      ],
      headerWaterway: [
        { text: "Waterway name", value: "name" },
        { text: "Geo trail", value: "geo2trail" },
      ],
      dataWaterway: [
        {
          name: "",
          geo2trail: false,
        },
      ],
    };
  },
  mounted() {
    this.getForms();

    bus.$on("set-form-data-in-vuex", () => this.setFormDataInVuex());
  },

  destroyed() {
    bus.$off("set-form-data-in-vuex");
  },

  methods: {
    ...mapActions(["GET_SIMULATION_FORMS", "setSimulationConfiguration"]),
    async getForms() {
      try {
        this.isLoading = true;
        const forms = await this.GET_SIMULATION_FORMS();
        this.data = forms;
        const tabsArray = this.data.map((obj) => obj.tabs);
        this.stepData = tabsArray;
        console.log(tabsArray);
      } catch (err) {
        console.log(err);
      } finally {
        this.isLoading = false;
      }
    },

    deleteItem(index, tableName) {
      if (tableName === "street_types") {
        this.dataStreets.splice(index, 1)
      }
      if (tableName === "surface_types") {
        this.dataSurface.splice(index, 1)
      }
      if (tableName === "railway_types") {
        this.dataRailway.splice(index, 1)
      }
      if (tableName === "waterway_types") {
        this.dataWaterway.splice(index, 1)
      }
    },

    setFormDataInVuex() {
      this.objectData["street_types"] = this.dataStreets;
      this.objectData["surface_types"] = this.dataSurface;
      this.objectData["railway_types"] = this.dataRailway;
      this.objectData["waterway_types"] = this.dataWaterway;
      this.setSimulationConfiguration(this.objectData);
    },

    addRowTable(tableName) {
      if (tableName === "street_types") {
        this.dataStreets.push({
          street_type_id: 0,
          geo2trail: false,
          width_meter: "",
          is_private: false,
          disable_secondary_side: false,
          side_cost_meter: "",
          crossing_cost_meter: "",
          permit_crossing: false,
          opt_cost_multiplier_crossing: "",
          urban_cost_multiplier: "",
        });
      }
      if (tableName === "surface_types") {
        this.dataSurface.push({
          surface_type_id: 0,
          cost_meter: 0,
        });
      }
      if (tableName === "railway_types") {
        this.dataRailway.push({
          name: "",
          crossing_cost: 0,
          geo2trail: false,
        });
      }
      if (tableName === "waterway_types") {
        this.dataWaterway.push({
          name: "",
          geo2trail: false,
        });
      }
    },

    valueTableUpdate(value, index, key, tableName, inputType) {
      if (tableName === "street_types") {
        if (inputType === "checkbox" && value === null) {
          this.dataStreets[index][key] = false;
        } else if(inputType === "number"){
          this.dataStreets[index][key] = Number(value);
        }else {
          this.dataStreets[index][key] = value;
        }
      }
      if (tableName === "surface_types") {
        if (inputType === "checkbox" && value === null) {
          this.dataSurface[index][key] = false;
        } else {
          this.dataSurface[index][key] = value;
        }
      }
      if (tableName === "railway_types") {
        if (inputType === "checkbox" && value === null) {
          this.dataRailway[index][key] = false;
        } else {
          this.dataRailway[index][key] = value;
        }
      }
      if (tableName === "waterway_types") {
        if (inputType === "checkbox" && value === null) {
          this.dataWaterway[index][key] = false;
        } else {
          this.dataWaterway[index][key] = value;
        }
      }
    },

    onStepClick(event) {
      this.currentStep = event;
    },
  },
};
</script>

<style scoped>
.configuration-buildings-container {
  width: 100%;
  height: calc(100% - 110px);
  display: flex;
}

.inputNPV {
  display: flex;
  flex-wrap: wrap;
  padding: 50px;
}

.inputNPVTable {
  display: flex;
  padding: 50px;
  flex-direction: column;
  align-items: flex-start;
}

.addButtonDiv {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
}

.addButtonNPV {
  height: 26px !important;
  width: 26px !important;
  min-width: auto !important;
  margin-bottom: 16px;
  color: #fff;
}

.formCard {
  width: 100%;
  margin-top: 18px;
  margin-left: 6px;
  max-width: 80%;
}

.scrollStep {
  position: absolute;
  max-height: calc(100% - 11px);
  width: calc(100% - 28px);
  left: 28px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow-y: scroll;
}

.stepperCard {
  position: relative;
  width: 278px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding: 11px 28px 11px 28px;
  margin-top: 18px;
}

.stepperTitle {
  color: #67a0b4;
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px; /* 150% */
  margin-bottom: 30px;
}
</style>

<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  width: 160px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/views/ConfigurationForms.vue